var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeuralnetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9,15a1,1,0,0,1-1-1V12a1,1,0,0,1,2,0v2A1,1,0,0,1,9,15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,15a1,1,0,0,1-1-1V12a1,1,0,0,1,2,0v2A1,1,0,0,1,15,15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6,8a1,1,0,0,1-.71-.29l-3-3A1,1,0,0,1,3.71,3.29l3,3a1,1,0,0,1,0,1.42A1,1,0,0,1,6,8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18,8a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42l3-3a1,1,0,1,1,1.42,1.42l-3,3A1,1,0,0,1,18,8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,20H3a1,1,0,0,1-1-1V14.5a10,10,0,0,1,20,0V19A1,1,0,0,1,21,20ZM4,18H20V14.5a8,8,0,0,0-16,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeuralnetwork);
export default __webpack_public_path__ + "static/media/neuralnetwork.3d0d7809e60d88468fdc639307df0579.svg";
export { ForwardRef as ReactComponent };